export default "__VITE_ASSET__D3DwGF1p__"